import api from 'api/instance';
import { FetchQueryType, FetchResponse } from 'types/common';
import { Contact } from 'types/user';

const URL = `${process.env.REACT_APP_API_URL}`;

type ContactsResponse = {
  message: string;
  items: Contact[];
};

export const fetchContacts = async (washHub?: string) => {
  const { data } = await api.get<ContactsResponse>(`${URL}/contact/list`, {
    params: {
      washHub,
      limit: 1000,
    },
  });

  return data?.items;
};

export const fetchPaginatedContacts = async (params: FetchQueryType) => {
  const { data } = await api.get<FetchResponse<Contact>>(
    `${URL}/contact/list`,
    {
      params,
    },
  );

  return data;
};

type CreateContactPayload = {
  fname: string;
  lname: string;
  role: string;
  site: string;
  washHub: string;
  phone: string;
  email: string;
};

export const createContact = async (payload: CreateContactPayload) => {
  const { data } = await api.post(`${URL}/contact/create`, payload);

  return data;
};

export const deleteContacts = async (ids: string[]) => {
  const { data } = await api.delete(`${URL}/contact/remove-many`, {
    data: {
      ids,
    },
  });

  return data;
};

export const updateContact = async (payload: any) => {
  const { _id, ..._payload } = payload;

  const { data } = await api.patch(`${URL}/contact/detail/${_id}`, _payload);

  return data;
};
